module.exports = __webpack_public_path__ + "static/media/dotlines.965ff9c6.svg";